// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"5ec928d4","513":"acbdd481","787":"1b4912a3"}[chunkId] + ".chunk.js";
};